const setFilesReport = (state, filesReport) => {
  state.filesReport = filesReport;
};

const setOrdersReport = (state, ordersReport) => {
  state.ordersReport = ordersReport;
};

const setCountReportFiles = (state, countReportFiles) => {
  state.countReportFiles = countReportFiles;
};

const setCountReportOrders = (state, countReportOrders) => {
  state.countReportOrders = countReportOrders;
};

const setPickupsReport = (state, pickupsReport) => {
  state.pickupsReport = pickupsReport;
}

const setDigitalizationReport = (state, digitalizationReport) => {
  state.digitalizationReport = digitalizationReport;
}

export default {
  setFilesReport,
  setOrdersReport,
  setCountReportFiles,
  setCountReportOrders,
  setPickupsReport,
  setDigitalizationReport
};



// WEBPACK FOOTER //
// ./src/store/modules/reports/mutations.js